import { createFileRoute } from '@tanstack/react-router'
import { PermissionRouteGuard } from '@/hooks/usePermissions'
import { FullPage } from '@/components/common/FullPage'
import { OrderFormStepper } from '@/components/features/orders/OrderFormStepper'

export const Route = createFileRoute('/_authenticated/orders_/new')({
  component: NewOrderGuard,
})

function NewOrderGuard() {
  return (
    <PermissionRouteGuard resource="orders" action="create">
      <FullPage title="New Order" maxWidth={960}>
        {(close) => (
          <OrderFormStepper
            onSuccess={close}
            onCancel={close}
          />
        )}
      </FullPage>
    </PermissionRouteGuard>
  )
}
